import { MpfInputBaseProps, mpfInputDefaults } from '../MpfInput/MpfInputBaseProps';

// ENG-20927 PDF uploads gated behind allowPdf prop (was re-enabled in ENG-17168, removed in ENG-20629)
const ACCEPT_ATTR = 'image/jpeg,image/png,image/tiff,.doc,.docx';

export interface MpfAttachmentsProps extends Omit<
  MpfInputBaseProps,
  'modelValue' | 'initialValue'
> {
  initialValue?: File[] | null;
  maxFiles?: number;
  maxFileSize?: number;
  modelValue?: File[] | null;
  accept?: string;
  allowPdf?: boolean;
  multiple?: boolean;
}

export type MpfAttachmentsEmits = {
  (e: 'update:modelValue', value: File[]): void;
};

export const mpfAttachmentsDefaults = {
  ...mpfInputDefaults,
  modelValue: null,
  maxFiles: 10,
  maxFileSize: 2 * 1024 * 1024, // 10MB
  accept: ACCEPT_ATTR,
  allowPdf: false,
  size: 'small',
};
